module.exports = __webpack_public_path__ + "img/天力保温杯.7cea7b2b.jpg";